import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.6545 11c1.9536 0 3.5373-1.567 3.5373-3.5S18.6081 4 16.6545 4c-1.9537 0-3.5374 1.567-3.5374 3.5s1.5837 3.5 3.5374 3.5zM7.55867 13.0003c.88736 0 1.72419-.212 2.46903-.58 1.8293.655 3.0896 2.01 3.0896 3.58v4H2v-4c0-1.57 1.2603-2.925 3.08961-3.58.74486.368 1.58169.58 2.46906.58zM11.0958 7.5c0 1.933-1.58372 3.5-3.53734 3.5-1.95361 0-3.53733-1.567-3.53733-3.5S5.60485 4 7.55846 4c1.95362 0 3.53734 1.567 3.53734 3.5zM14.1856 12.4203c.7449.368 1.5817.58 2.4691.58.8873 0 1.7242-.212 2.469-.58 1.8293.655 3.0896 2.01 3.0896 3.58v4h-7.0746v-4c0-1.284-.4872-2.459-1.322-3.424.0333-.0144.0663-.0292.0993-.0439.0881-.0393.1762-.0786.2696-.1121z",
    fill: "currentColor"
  }));
});